import { Stack } from '@mui/material';
import { useNavigate, useParams } from 'react-router';
import { Description } from './components/description';
import { RefundRequests } from './components/refund-requests';
import { RequestData } from './components/request-data';
import { PageContainer } from '@/components/shared/page-container';
import { PageHeader } from '@/components/shared/page-header';
import { useResourceApprovalsDetails } from '@/data/subsidy/resource-approvals/details';
import { Skeleton } from '@/packages/subsidy-management/components/skeleton';

export const ResourceApprovalDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { resourceApprovalsDetails, isLoading } = useResourceApprovalsDetails(
    id || ''
  );

  return (
    <PageContainer>
      <PageHeader
        backNavigationText="Gestão de reembolsos"
        handleBackNavigation={() => navigate('/empresa/gestao-de-reembolsos')}
      />
      <Stack gap={2}>
        {isLoading && <Skeleton />}
        {resourceApprovalsDetails && (
          <>
            <RequestData resourceApprovalsDetails={resourceApprovalsDetails} />
            <Description resourceApprovalsDetails={resourceApprovalsDetails} />
            <RefundRequests
              resourceApprovalsDetails={resourceApprovalsDetails}
            />
          </>
        )}
      </Stack>
    </PageContainer>
  );
};
